<template>
  <div>
    <div class="container_footer">
      <v-fab-transition>
        <v-btn
          class="btn_float v-btn--example"
          color="info"
          fab
          large
          dark
          @click="goToTakePicture"
        >
          <v-icon>mdi-camera</v-icon>
        </v-btn>
      </v-fab-transition>

      <Footer>
        <div class="footer_logbook">
          <p>Imágenes</p>
          <p>{{ captureCount }}</p>
          <v-btn text
            ><v-icon color="white" @click="goToDetail"
              >mdi-notebook-multiple</v-icon
            ></v-btn
          >
        </div>
      </Footer>
    </div>
    <v-dialog v-model="dialog" max-width="270">
      <v-card>
        <v-card-text class="pa-4 text-center" style="display:grid">
          <v-icon large color="primary">mdi-information-outline</v-icon>
          Al menos debe de tomar una evidencia fotográfica
        </v-card-text>

        <v-card-actions class="justify-center">
          <v-btn color="green darken-1" text @click="dialog = false">
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import Footer from "@/components/Footer";

export default {
  components: {
    Footer,
  },
  data() {
    return {
      dialog: false,
      organizationId: localStorage.getItem("organizationId"),
    };
  },
  created() {
    this.SET_LOGBOOK_VIEW(true);
    this.SET_APPBAR_OPTIONS({
      leftButton: "menu",
      rightButton: "close",
      funcRightButton: this.close,
    });
  },
  beforeDestroy() {
    this.SET_LOGBOOK_VIEW(false);
  },
  computed: {
    ...mapState("logs", ["captureCount", "evidences"]),
    ...mapState("areasList", ["areaSelected"]),
  },
  methods: {
    ...mapMutations("logs", [
      "SET_LOGBOOK_VIEW",
      "SET_LOG_SELECTED",
      "SET_AREA_SELECTED_LOGS",
      "CLEAR_STATE",
    ]),
    ...mapMutations(["SET_APPBAR_OPTIONS"]),

    goToTakePicture() {
      this.$router.push("/photoLogbook");
    },
    goToDetail() {
      if (this.evidences.length > 0) {
        const log = {
          soilArea: this.areaSelected._id,
          organizationId: this.organizationId,
          photographicEvidence: this.evidences,
        };
        this.SET_LOG_SELECTED(log);
        this.SET_AREA_SELECTED_LOGS(this.areaSelected);
        this.$router.push("/detail-log?new=true");
      } else {
        this.dialog = true;
      }
    },
    close() {
      this.CLEAR_STATE();
      this.$router.push("/territory");
    },
  },
};
</script>

<style scoped>
.container_footer {
  position: absolute;
  bottom: 0%;
  width: 100%;
}
.btn_float {
  position: absolute;
  bottom: 100px;
  left: 43%;
}
.footer_logbook {
  align-items: baseline;
  display: flex;
  justify-content: space-around;
  color: white;
  width: 100%;
}
</style>
